namespace SP {
    export function dataEquals(one: any, two: any) {
        if (one === two) return true;
        if (typeof (one) != typeof (two)) return false;
        if (Array.isArray(one) != Array.isArray(two)) return false;

        if (Array.isArray(one)) {
            for (let i = 0; i < one.length; i++) {
                if (two[i] != one[i]) return false;
            }

            for (let i = 0; i < two.length; i++) {
                if (one[i] != two[i]) return false;
            }
        }
        else {
            for (var name in one) {
                if (two[name] != one[name])
                    return false;
            }
            for (var name in two) {
                if (one[name] != two[name])
                    return false;
            }
        }
        return true;
    }
}